const BASE_URL = process.env.REACT_APP_API_URL || '/svc';

const TOKEN_KEY = 'auth_token';

export const getToken = () => localStorage.getItem(TOKEN_KEY);
export const saveToken = (token) => localStorage.setItem(TOKEN_KEY, token);
export const removeToken = () => localStorage.removeItem(TOKEN_KEY);

async function request(method, path, body = null, auth = true) {
  const headers = { 'Content-Type': 'application/json' };
  if (auth) {
    const token = getToken();
    if (token) headers['Authorization'] = `Bearer ${token}`;
  }
  let res;
  try {
    const controller = new AbortController();
    const timer = setTimeout(() => controller.abort(), 10000);
    res = await fetch(`${BASE_URL}${path}`, {
      method,
      headers,
      body: body ? JSON.stringify(body) : undefined,
      signal: controller.signal,
    });
    clearTimeout(timer);
  } catch (e) {
    if (e?.name === 'AbortError') throw new Error('Сервер не отвечает');
    throw new Error('Нет соединения с сервером');
  }
  const data = await res.json().catch(() => ({}));
  if (!res.ok) {
    const err = new Error(data.detail || 'Ошибка сервера');
    err.status = res.status;
    err.detail = data.detail;
    throw err;
  }
  return data;
}

export const api = {
  auth: {
    register:      (body) => request('POST', '/auth/register', body, false),
    verify:        (body) => request('POST', '/auth/verify', body, false),
    login:         (body) => request('POST', '/auth/login', body, false),
    me:            ()     => request('GET',  '/auth/me'),
    forgotPassword:(body) => request('POST', '/auth/forgot-password', body, false),
    resetPassword: (body) => request('POST', '/auth/reset-password', body, false),
  },
  products: {
    list: () => request('GET', '/products/', null, false),
    updatePrice: (id, price) => request('PATCH', `/products/${id}/price`, { price }),
  },
  orders: {
    create:      (body) => request('POST',  '/orders/', body),
    createBatch: (body) => request('POST',  '/orders/batch', body),
    my:          ()     => request('GET',   '/orders/my'),
    adminAll:    ()     => request('GET',   '/orders/admin/all'),
    take:        (id)   => request('PATCH', `/orders/${id}/take`, {}),
    release:     (id)   => request('PATCH', `/orders/${id}/release`, {}),
    deliver:     (id, payment_method) => request('PATCH', `/orders/${id}/deliver`, { payment_method }),
    cancel:      (id, cancel_reason)  => request('PATCH', `/orders/${id}/cancel`, { cancel_reason }),
    edit:        (id, body) => request('PATCH', `/orders/${id}/edit`, body),
    get:         (id)   => request('GET',   `/orders/${id}`),
    export:      (from_, to_) => request('GET', `/orders/admin/export?date_from=${from_}&date_to=${to_}`),
  },
  profile: {
    get:         () => request('GET',   '/profile/'),
    update:      (body) => request('PATCH', '/profile/', body),
    users:       () => request('GET',   '/profile/users'),
    admins:      () => request('GET',   '/profile/admins'),
    toggleAdmin: (userId) => request('PATCH', `/profile/users/${userId}/admin`, {}),
  },
  announcements: {
    active: () => request('GET', '/announcements/active', null, false),
    list:   () => request('GET', '/announcements/'),
    create: (message) => request('POST', '/announcements/', { message }),
    toggle: (id) => request('PATCH', `/announcements/${id}/toggle`, {}),
    delete: (id) => request('DELETE', `/announcements/${id}`),
  },
  settings: {
    get:    () => request('GET',   '/settings/', null, false),
    update: (body) => request('PATCH', '/settings/', body),
  },
  chat: {
    messages:           (limit = 30, offset = 0) => request('GET', `/chat/messages?limit=${limit}&offset=${offset}`),
    clearMessages:      () => request('DELETE', '/chat/messages'),
    conversations:      () => request('GET', '/chat/conversations'),
    conversation:       (userId) => request('GET', `/chat/conversations/${userId}`),
    deleteConversation: (userId) => request('DELETE', `/chat/conversations/${userId}`),
  },
};
